import { PARTIAL } from './SearchTypes';
export const initialSearchState = {
  term: '',
  searchType: PARTIAL
};